module.exports = __webpack_public_path__ + "static/media/logo.6eaa3b1c.png";